import React, { useMemo, useRef, useState } from 'react';
import CardCommon from '@op/components/CardCommon';
import PercentageItem from '@op/components/Snippets/PercentageItem';
import { Col, Row } from 'tea-component';
import { ChannelChart, LanguageChart } from './CommonChart';
import { ChartEventInjectedProps } from '@op/pages/Detail/component/chartEvent';
import { DBO_TM, DBO_V } from '@op/utils/format';
import RingRatioBubble from '@op/components/Snippets/RingRatioBubble';
import { keyMetricObj, keyMetricsArray } from '../constants';
import './index.scss';
import useLanguage from '@op/hooks/useLanguage';
export default function DoubleCharts(
  props: ChartEventInjectedProps & { metric: string },
) {
  const { metric } = props;
  const { formatMessage } = useLanguage();
  const [weeklyData, setWeeklyData] = useState<{
    avg_five_week: number;
    this_week: number;
    avg_five_week_time: {
      link_of_start_time: string;
      link_of_end_time: string;
    };
    this_week_time: { link_of_start_time: string; link_of_end_time: string };
  } | null>(null);

  const metricItemRef = useRef(keyMetricObj[metric] || keyMetricsArray[0]);

  const { isEmpty, bubbleData, value } = useMemo(() => {
    if (!weeklyData) {
      return { isEmpty: true };
    }
    const { avg_five_week, this_week, avg_five_week_time, this_week_time } =
      weeklyData;

    const bubbleData = {
      newValue: this_week,
      oldValue: avg_five_week,
      newTime: [
        this_week_time?.link_of_start_time,
        this_week_time?.link_of_end_time,
      ],
      oldTime: [
        avg_five_week_time?.link_of_start_time,
        avg_five_week_time?.link_of_end_time,
      ],
    };

    return {
      isEmpty: false,
      bubbleData,
      value: DBO_V.qoq(this_week, avg_five_week),
    };
  }, [weeklyData]);

  return (
    <CardCommon
      title={
        <div className="dbo-card-title-info">
          <div className="dbo-card-title-info-title">
            {formatMessage('Compared with Average')}
          </div>
          {!isEmpty && (
            <RingRatioBubble
              {...bubbleData!}
              formateValue={metricItemRef.current?.format}
              formateDate={DBO_TM.formatFunc('weekly')}
            >
              <PercentageItem percentage={value!}></PercentageItem>
            </RingRatioBubble>
          )}
          <div style={{ marginLeft: 10 }} className="dbo-card-title-info-desc">
            {formatMessage('Click the chart to filter the feeds data below')}
          </div>
        </div>
      }
      className="dbo-double-charts-wrapper"
    >
      <Row>
        <Col>
          <ChannelChart
            metricItemRef={metricItemRef}
            setWeeklyData={setWeeklyData}
            {...props}
          ></ChannelChart>
        </Col>
        <Col>
          <LanguageChart
            metricItemRef={metricItemRef}
            {...props}
          ></LanguageChart>
        </Col>
      </Row>
    </CardCommon>
  );
}
